import { render, staticRenderFns } from "./CragsTable.vue?vue&type=template&id=6914f8ad&scoped=true"
import script from "./CragsTable.vue?vue&type=script&lang=js"
export * from "./CragsTable.vue?vue&type=script&lang=js"
import style0 from "./CragsTable.vue?vue&type=style&index=0&id=6914f8ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6914f8ad",
  null
  
)

export default component.exports